export const BASE_URL = "https://my.dsign.ro/";
export const API_BASE_URL = "https://my.dsign.ro/backend/api";

export const API_TIMEOUT_MS = 15000;
